import { DatePicker, Input, Pagination, Select, Table } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
// import { getBetHistory } from '../../redux/slice/betHistory/betHistorySlice';
import Loader from "components/loader";
import Appconfig from '../../config/config'
import { getMarketAnalysis } from "../../redux/slice/marketAnalysis/marketAnalysisSlice";
import { setCurrentEventId } from "../../redux/slice/events/eventsSlice";
import { useNavigate } from "react-router-dom";

function MarketAnalysis() {
    const navigate = useNavigate()
    const { userdata, isAuthenticated } = useSelector((state) => state.authSlice);
    const dispatch = useDispatch();
    const { data, loading } = useSelector((state) => state.marketAnalysis);

    useEffect(() => {
        if (isAuthenticated) {
            dispatch(getMarketAnalysis());
        }
    }, [dispatch, isAuthenticated]);

    return (
        <div className='relative min-w-full'>
            <div className='grid grid-cols-12 relative p-[15px] ' >
                <div className='col-span-12  '>
                    <div className=' w-full'>
                        <div className='font-bold text-[0.938rem] leading-[23px] bg-[linear-gradient(#022c43,_#18b0c8)] px-[10px] py-[5px] text-[#ffffff] rounded-tl-[calc(.25rem-1px)] rounded-br-[0] rounded-tr-[calc(.25rem-1px)] rounded-bl-[0]'>
                            My Market
                        </div>
                    </div>
                </div>

                <div className="col-span-12 overflow-x-auto">
                    <table className="w-full whitespace-nowrap !mb-6 text-[#212529]">
                        {
                            data?.map((item, index) => (
                                <>
                                    <thead className=''>
                                        <tr className="!bg-[#028dad] !text-[#ffffff]">
                                            <th className='p-[4px]  border-[#fff] border-[1px] align-bottom border-b-[#dee2e6]  border-b-[2px] '>S.No</th>
                                            <th className='p-[4px] border-[#fff] border-[1px] align-bottom border-b-[#dee2e6]  border-b-[2px] '>Match Name</th>
                                            <th className='p-[4px] border-[#fff] border-[1px] align-bottom border-b-[#dee2e6]  border-b-[2px] '>Date</th>
                                            <th className='p-[4px] border-[#fff] border-[1px] align-bottom border-b-[#dee2e6]  border-b-[2px] '>Sport Name</th>
                                            <th className='p-[4px] border-[#fff] border-[1px] align-bottom border-b-[#dee2e6]  border-b-[2px] '>Match Status</th>

                                            {
                                                item?.exposure?.map((e, i) => (
                                                    e?.selection_id &&
                                                    <th key={i} className='p-[4px] border-[#fff] border-[1px] align-bottom border-b-[#dee2e6]  border-b-[2px] '>{e?.runner_name}</th>
                                                ))
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr className="cursor-pointer" onClick={() => {
                                            navigate(`/event/${item?.event_type}/${item?.match_id}`)
                                            dispatch(setCurrentEventId(item?.match_id))
                                        }}>

                                            <td key={index} className='p-[4px] border-[#dee2e6] border-[1px] align-bottom border-b-[#dee2e6]  border-b-[2px] '>
                                                {index + 1}.
                                            </td>
                                            <td key={index} className='p-[4px] text-[#4083a9] border-[#dee2e6] border-[1px] align-bottom border-b-[#dee2e6]  border-b-[2px] '>
                                                {item.event_name}
                                            </td>
                                            <td key={index} className='p-[4px] border-[#dee2e6] border-[1px] align-bottom border-b-[#dee2e6]  border-b-[2px] '>
                                                {new Date(item.createdAt).toLocaleString("en-GB", {
                                                    day: "2-digit",
                                                    month: "2-digit",
                                                    year: "numeric",
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                    second: "2-digit",
                                                    hour12: true,
                                                })}
                                            </td>
                                            <td key={index} className='p-[4px] border-[#dee2e6] border-[1px] align-bottom border-b-[#dee2e6]  border-b-[2px] '>
                                                {item.event_type == 1 ? 'Soccer' : item?.event_type == 2 ? 'Tennis' : 'Cricket'}
                                            </td>
                                            <td key={index} className='p-[4px] border-[#dee2e6] border-[1px] align-bottom border-b-[#dee2e6]  border-b-[2px] '>
                                                Open
                                            </td>
                                            {
                                                item?.exposure?.map((e, i) => (
                                                    e?.selection_id &&
                                                    <td key={i} className={`p-[4px] border-[#dee2e6] border-[1px] align-bottom border-b-[#dee2e6]  border-b-[2px] ${e?.total_pl > 0 ? 'text-[#508d0e]' : 'text-[#d9534f]'}`}>
                                                        {e?.total_pl}
                                                    </td>
                                                ))
                                            }
                                        </tr>
                                    </tbody>
                                </>
                            ))
                        }
                    </table>
                </div>
            </div>
        </div>
    )
}


export default MarketAnalysis;
